import { Navigate } from 'react-router-dom';
import { useSession } from '../auth/authQueries';
import { CenteredCardLayout } from '../components/layout/CenteredCardLayout';
import { Spinner } from '../components/ui';
import { ROUTES } from '../lib/routes';
import { toSafeTarget } from '../lib/safeNavigation';

/** Index route ("/"): redirect by session state (spec §6). */
export default function RootRedirect() {
  const session = useSession();

  if (session.isLoading) {
    return (
      <CenteredCardLayout>
        <div className="stack" style={{ alignItems: 'center' }}>
          <Spinner label="Đang tải…" />
        </div>
      </CenteredCardLayout>
    );
  }

  if (!session.data?.authenticated) {
    return <Navigate to={ROUTES.login} replace />;
  }
  if (session.data.user.status === 'PENDING_ONBOARDING') {
    return <Navigate to={ROUTES.onboarding} replace />;
  }
  return <Navigate to={toSafeTarget(session.data.nextUrl, ROUTES.account)} replace />;
}
